import { render, staticRenderFns } from "./ReferClient.vue?vue&type=template&id=30f12c3a"
import script from "./ReferClient.vue?vue&type=script&lang=js"
export * from "./ReferClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports